import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, OrgJedView, ModalService, NotificationService } from 'yt-ng-framework';
import { User } from './user';
import { ActivatedRoute } from '@angular/router';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-user-update',
  templateUrl: './user-update.component.html'
})
export class UserUpdateComponent extends BaseUpdateComponent<User> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);
  }

  isNew: boolean = false;
  showPassword: boolean = false;
  
  orgJedFormGroup: FormGroup = new FormGroup({
    selectedOrgJedID: new FormControl()
  });

  userOrgJedList: OrgJedView[];

  ngOnInit() {
    this.addValidatorToFc("Password", Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&\.]).{6,}'),'pattern',"USER.PASSWORD.VALIDATION.PATTERN")
    super.ngOnInit();

    this.IDProcessed
      .subscribe(value => {
        this.isNew = false;
        if(value && this.Item.ID == -1)
          this.isNew = true;
        else if(value && this.Item.ID > 0)
          this.LoadOrgJed();
      })
  }

  AddOrgJedToUser(){
    let parameters = { UserID: this.Item.ID, OrgJedID: this.orgJedFormGroup.get('selectedOrgJedID').value };
    this.baseDataService.Post('user', 'addOrgJedToUser', parameters, null)
      .subscribe(() => {
        // this.notificationsService.success('Uspešno', 'Sačuvan');
        this.toastrService.success('Uspešno', 'Sačuvan');
      })
  }

  LoadOrgJed(){
    this.baseDataService.Get('orgJed', 'getByUserID', [new QueryParameter('userID', this.Item.ID)], OrgJedView)
      .subscribe(data => {
        this.userOrgJedList = data;
      })
  }

}
